import moment from 'moment';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../context/Auth';
import { useEffect, useState } from 'react';
import api from '../utils/api';
import ItemBillet from './item-billet';
import ItemReceiverDetails from './item-receiver-details';

const Dash = () => {
  const { userInfos } = useAuthContext();
  const [dash, setDash] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getDash();
  }, []);

  const getDash = () => {
    api.get('/dashboard', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        setDash(res.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {userInfos?.name && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6 mt-6 md:mt-0">
          <h6 className="text-xl">Olá {userInfos?.name}!</h6>
        </div>
      )}

      {localStorage.getItem('profile') == 'company' && (
        <>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="bg-white shadow-md rounded-lg p-6">
                <h2 className="text-lg font-semibold">
                  {index === 0 ? 'Total em R$' : index === 1 ? 'Total de boletos' : 'Total de recebedores'}
                </h2>
                <div className="flex justify-between mt-4">
                  {isLoading ? (
                    <div className="h-7 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                  ) : (
                    <p className="text-xl font-bold text-blue-500">
                      {index === 0
                        ? parseFloat(dash?.total_billet).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })
                        : index === 1
                        ? dash?.count_billets
                        : dash?.count_receivers}
                    </p>
                  )}
                  {!isLoading && (
                    <Link
                      to={index === 1 ? '/billets' : '/receivers'}
                      className="mt-4 block text-blue-500 hover:underline"
                    >
                      Ver todos
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6">
            <div className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-xl font-semibold">Últimos Boletos Criados</h2>
              <div className="overflow-x-auto w-full">
                <table className="min-w-full mt-4 table-auto border-collapse">
                  <thead>
                    <tr className="border-b">
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Valor</th>
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Taxa LucroTech</th>
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Data de Vencimento</th>
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Status</th>
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700"></th>
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700"></th>
                      <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading
                      ? [...Array(3)].map((_, index) => (
                          <tr key={index} className="border-b">
                            <td className="py-4 px-4">
                              <div className="h-6 w-20 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                            <td className="py-4 px-4">
                              <div className="h-6 w-28 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                            <td className="py-4 px-4">
                              <div className="h-6 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                            <td className="py-4 px-4">
                              <div className="h-6 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                            <td className="py-4 px-4">
                              <div className="h-6 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                            <td className="py-4 px-4">
                              <div className="h-6 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                            <td className="py-4 px-4">
                              <div className="h-6 w-24 bg-gray-300 animate-pulse rounded-md"></div>
                            </td>
                          </tr>
                        ))
                      : dash?.last_billets?.map((billet, index) => <ItemBillet key={index} billet={billet} />)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}

      {localStorage.getItem('profile') == 'receiver' && (
        <>
          <ItemReceiverDetails receiver={userInfos?.receiver_id} />
        </>
      )}
    </>
  );
};

export default Dash;
